<div class="pv">
  <header class="pv-head">
    <span class="pv-icon"><i-tabler name="file-type-pdf" class="icon-18"></i-tabler></span>
    <span class="pv-title" [title]="title">{{ title }}</span>
    <button type="button" class="pv-btn" (click)="openInTab()" [disabled]="loading || error"
            [matTooltip]="'documents.viewer_open_tab' | translate" [attr.aria-label]="'documents.viewer_open_tab' | translate">
      <i-tabler name="external-link" class="icon-18"></i-tabler>
    </button>
    <button type="button" class="pv-btn" (click)="closed.emit()"
            [matTooltip]="'documents.close' | translate" [attr.aria-label]="'documents.close' | translate">
      <i-tabler name="x" class="icon-18"></i-tabler>
    </button>
  </header>

  @if (citedPages.length) {
    <div class="pv-cited">
      <span>{{ 'documents.viewer_cited' | translate }}</span>
      @for (p of citedPages; track p) {
        <button type="button" [class.active]="p === current" (click)="goTo(p)">{{ p }}</button>
      }
    </div>
  }

  <div class="pv-stage" #stage>
    @if (loading) {
      <div class="pv-state"><mat-spinner diameter="30"></mat-spinner></div>
    } @else if (error) {
      <div class="pv-state">
        <i-tabler name="file-alert" class="icon-32"></i-tabler>
        <p>{{ 'documents.viewer_error' | translate }}</p>
      </div>
    }
    <canvas #canvas [class.hidden]="loading || error" [class.cited]="isCited(current)"></canvas>
  </div>

  <footer class="pv-foot">
    <button type="button" class="pv-btn" (click)="prev()" [disabled]="loading || current <= 1"
            [attr.aria-label]="'documents.viewer_prev' | translate">
      <i-tabler name="chevron-left" class="icon-18"></i-tabler>
    </button>
    <span class="pv-page">{{ 'documents.pages' | translate }} {{ current }} / {{ pageCount || '…' }}</span>
    <button type="button" class="pv-btn" (click)="next()" [disabled]="loading || current >= pageCount"
            [attr.aria-label]="'documents.viewer_next' | translate">
      <i-tabler name="chevron-right" class="icon-18"></i-tabler>
    </button>
    <span class="pv-sep"></span>
    <button type="button" class="pv-btn" (click)="zoom(-1)" [disabled]="loading || zoomIndex === 0" aria-label="-">
      <i-tabler name="zoom-out" class="icon-18"></i-tabler>
    </button>
    <span class="pv-zoom">{{ zoomLabel }}</span>
    <button type="button" class="pv-btn" (click)="zoom(1)" [disabled]="loading || zoomIndex === 4" aria-label="+">
      <i-tabler name="zoom-in" class="icon-18"></i-tabler>
    </button>
  </footer>
</div>
